module.exports = __webpack_public_path__ + "static/media/mute-watermark-icon.85d23c0d.svg";